<template>
  <div style="padding-bottom: 44px">
    <div class="MyHeader">
      <!--
      <div class="MyTop">
         <router-link to="/home" tag="span"><a href="javascript:void(0);" class="icon-back" ></a> <i>返回</i></router-link><h3>我的</h3><span><a href="javascript:void(0);" @click="cancel=true" class="icon-menu"></a></span>
       </div> -->
      <div class="cbox">
        <div class="MyPortrait MyPortrait_top clearfix" v-if="MyPortrait">
          <div class="MyPortrait_div">
            <span class="MyTop" @click="fn()"><a href="javascript:void(0);" class="icon-back"></a> <i>返回</i></span>
            <div class="My_con">
              <img :src="headPortrait" alt=""/>
            </div>
            <div class="MyPortraitFile" @click="showActivityUser"></div>
          </div>
        </div>
      </div>
      <div class="cbox">
        <div class="MyPortrait" v-if="MyPortrait">
          <h4>{{nickname}} <span class="MyPortrait_pa" @click="signOut">退出</span></h4>
          <p>用户ID : {{userId}}</p>
        </div>

        <div v-else class="MyPortrait MyPortrait_top" @click="login">
          <!-- <router-link class="MyPortrait MyPortrait_top" to="/login" tag="div" v-else> -->
          <div class="My_con">
            <img src="../../static/dist/image/NotLogged.png" alt=""/>
          </div>
          <h4 class="nav-on">点击登录或注册</h4>
          <p></p>
          <!-- </router-link> -->
        </div>
      </div>
      <div class="MyMenu" v-if="MyPortrait">
        <router-link class="icon-title" to="/myparticipate/0" tag="dl">

          <dd>{{count.event_count}}</dd>
          <dt>参与的</dt>
        </router-link>
        <router-link class="icon-title" to="/myfollow" tag="dl">

          <dd>{{count.fav_count}}</dd>
          <dt>关注的</dt>
        </router-link>
        <router-link class="icon-title" to="/myupload" tag="dl">

          <dd>{{count.video_count}}</dd>
          <dt>上传的</dt>
        </router-link>
        <router-link class="icon-title" to="/mynotice" tag="dl">

          <dd v-if="count.msg">{{count.msg}}</dd>
          <dd v-else>0</dd>
          <dt>@我的</dt>
        </router-link>
      </div>
      <div class="MyMenu" v-else @click="login">
        <dl class="icon-title">
          <dd>0</dd>
          <dt>参与的</dt>

        </dl>
        <dl class="icon-title">
          <dd>0</dd>
          <dt>关注的</dt>

        </dl>
        <dl class="icon-title">
          <dd>0</dd>
          <dt>上传的</dt>

        </dl>
        <dl class="icon-title">
          <dd>0</dd>
          <dt>@我的</dt>

        </dl>
      </div>
    </div>
    <div class="MyConent">
      <!--   <div class="MyPrompt" v-if="MyPortrait && countmes != null">
          <div>
              <div class="MyPrompt-img"><img v-if="countmes" :src="JSON.parse(countmes.content).host_avatar" alt=""/></div>
             <router-link  class="MyPrompt-div" to="/myActivity/MyNotice" tag="div">
              </router-link>
              <div class="MyPromptFixe" style="z-index: 99">
                {{count.msg_count}}
              </div>
          </div>
         </div> -->
      <div class="cbox">
        <div class="MyPerfect " v-if="MyPortrait" @click="showActivityUser">
          <h5>完善我的个人信息</h5>
          <p>个人信息会在报名时自动匹配</p>
        </div>
        <!-- <router-link class="MyPerfect" to="/login" tag="div" v-else> -->
        <div class="MyPerfect" v-else @click="login">
          <h5>完善我的个人信息</h5>
          <p>个人信息会在报名时自动匹配</p>
        </div>
      </div>
      <!-- </router-link> -->
      <h5 class="Newest-title" v-if="TablesName">最新征集推荐</h5>
      <div class="show-box">
        <div class="swiper-container show-poll-swiper show-id-swiper">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(v,ind) in TablesName">
              <ul class="show-list">
                <!-- <router-link tag="li"  v-for="(val,i) in TwoNumbers"  v-if="Tables[ind*2+i]" :to="{name:'Detail',params: {id: Tables[ind*2+i].id}}"> -->
                <li v-for="(val,i) in TwoNumbers" v-if="Tables[ind*2+i]" @click="route(Tables[ind*2+i].id)">
                  <a href="javascript:void(0);">
                    <div class="show-remd-logo" v-if="Tables[ind*2+i].hostunit">
                      <img :src="Tables[ind*2+i].hostunit.host_avatar" alt=""/>
                    </div>
                    <div class="show-remd-tit" v-if="Tables[ind*2+i].hostunit">
                      {{Tables[ind*2+i].hostunit.channel_name}}
                    </div>
                    <div class="pic-box">
                      <img :src="Tables[ind*2+i].playbill.playbill_small_h5 + '?p=3&o=2&w=350&h=197'" alt=""/>
                      <!-- <i class="icon-time">01.02</i> -->
                    </div>
                    <p>{{Tables[ind*2+i].title}}</p>
                  </a>
                </li>
                <!-- </router-link> -->
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="nav-bottom">
      <router-link class="icon-title" to="/home">
        <i class="icon-index"></i>
        发现
      </router-link>
      <!--router-link class="icon-title" to="/discovery">
        <i class="icon-find"></i>
        发现
      </router-link-->
      <router-link class="nav-on" to="/mymessage">
        <i class="icon-mine"></i>
        我的
      </router-link>
    </div>

    <div id="modal_content">
      <div>
        <div class="title">完善个人信息</div>
        <div class="z-content" v-if="myMessage">
          <p>
            <label>姓名</label>
            <input class="myName" type="text" :value="myMessage.name" placeholder="请输入姓名"/>
          </p>
          <p></p>
          <label>性别</label>
          <div class="content-myGender">
            <span class="conten-span"><input type="radio" class="sex" name="myGender" value="男"
                                             :checked="myMessage.sex == '男'"/>男</span>
            <span class="conten-span"><input type="radio" class="sex" name="myGender" value="女"
                                             :checked="myMessage.sex == '女'"/>女</span>
          </div>
          <p>
            <!-- 地区 -->
            <label>地址</label>
            <Linkage @message="listenToMyBoy" :text="address"></Linkage>
            <input class="address" style="display: none;" type="text" :value="region"/>
          </p>
          <div class="group detailed">
            <label>详细地址</label>
            <div class="et-typebox">
              <input class="form-control" style="width: 100%;height: 45px;padding-left: 5px;" type="text"
                     placeholder="请输入详细地址"/>
            </div>
          </div>
          <p>
            <label>电话</label>
            <input class="myTelephone" @keyup="SmallKeyup($event)" type="text" :value="myMessage.mobile"
                   placeholder="请输入手机号"/>
            <span style="display: none; font-size: 14px;color: #C8494E;">
              请输入正确手机号！
            </span>
          </p>
        </div>

        <div class="z-content" v-else>
          <p>
            <label>姓名</label>
            <input class="myName" type="text" value="" placeholder="请输入姓名"/>
          </p>
          <p class="cotent-sex">
            <label>性别</label>
          <div class="content-myGender 222">
            <span @click="sexCheckfn(1)" class="conten-span"><input type="radio" class="sex" name="myGender" value="男"/>男 </span>
            <span @click="sexCheckfn(2)" class="conten-span"><input type="radio" class="sex" name="myGender" value="女"/>女 </span>
          </div>
          </p>
          <p>
            <!-- 地区-->
            <label>地址</label>
            <Linkage @message="listenToMyBoy" :text="address"></Linkage>
            <input class="address" style="display: none" type="text" :value="region"/>
          </p>
          <div class="group detailed">
            <label>详细地址</label>
            <div class="et-typebox">
              <input class="form-control" style="width: 100%;height: 45px;padding-left: 5px;" type="text"
                     placeholder="请输入详细地址"/>
            </div>
          </div>
          <p>
            <label>电话</label>
            <input class="myTelephone" @keyup="SmallKeyup($event)" type="text" value="" placeholder="请输入手机号"/>
            <span style="display: none; font-size: 14px;color: #C8494E;">
              请输入正确手机号码！
            </span>
          </p>
        </div>
        <div class="btn-modal-tw clearfix">
          <button id="Button1" class="btn-1 buttonW buttonL" type="button" @click="myHas(1)">确定</button>
          <button id="cancel" class="btn-2 buttonW buttonR" @click="myHas(0)">取消</button>
         <!-- </a>-->
        </div>
      </div>
    </div>

    <!--   <UserContentr></UserContentr>-->
  </div>
</template>

<script>
  import Linkage from './template/linkage.vue'
  import userContentr from './myMessage/userContenr.vue'

  export default {
    name: 'MyMessage',
    data() {
      return {
        cancel: false,
        MyPortrait: true,
        total: 0,        // 上传个数
        Tables: '',      // 首页最新征集推荐
        TablesName: '',  // 首页最新征集推荐数量
        TwoNumbers: 2,
        userId: '',
        count: '',
        countmes: '',
        nickname: '',
        headPortrait: '',
        region: '',
        address: '',
        myMessage: '',
        sexCheck: ''
      }
    }
    ,
    methods: {
      route(id) {
        var url = '';
        var hrefHTML = this.hrefHTML(0, id)
        if (hrefHTML) {
          window.location.href = hrefHTML
        } else {
          window.location.href = API.UrlName + 'detail/' + id
        }
      },
      login() {
        var that = this;
        // if (!that.loginFn()) {
          that.$router.push({name: 'login_Quick'})
        // }
      },
      sexCheckfn(i) {
        if (i == 1) {
          this.sexCheck = '男'
        } else {
          this.sexCheck = '女'
        }
      },
      fn() {
        // this.$router.push({name: 'HomeIndex'})
        this.$router.go(-1);
      },
      // 操作按钮事件
      signOut() {// 退出
        var that = this
        var from = 'passport';
        passport.logout(from, fn);

        function fn() {
          window.sessionStorage.setItem('userId', '');
          that.$router.push({name: 'HomeIndex'})
        }
        setTimeout(function () {
          window.sessionStorage.setItem('userId', '');
          that.$router.push({name: 'HomeIndex'})
        }, 1000)
      },
      listenToMyBoy(somedata) {
        this.region = somedata
      },
      // 获取信息
      showActivityUser() {
        $('#modal_content').css('left', '0');
        var that = this;
        this.$http.get(API.ShowActivityUser)
          .then(function (res) {
            //console.log(res)
            if (res.code == 0) {
              if (res.data.content) {
                that.myMessage = res.data.content;
                /// console.log(that.myMessage)
                that.sexCheck = that.myMessage.sex;
                if (that.myMessage && that.myMessage.address) {
                  that.address = that.myMessage.address
                } else {
                  that.address = ''
                }
              }
            }
          })
        $('#detailAlert').modal('show')
      },
      SmallKeyup(event) {
        var itself = event.target,
          val = $(itself).val();
        var reg = /^[1][3,4,5,7,8][0-9]{9}$/;

        if (!reg.test(val)) {
          $(itself).next().show();
          $('#Button1').css('pointer-events', 'none');
          return false;
        } else {
          $(itself).next().hide();
          $('#Button1').css('pointer-events', 'visible');
        }
      },
      // 修改信息
      myHas(val) {
        if (val == 0) {
          $('#modal_content').css('left', '-120%');
          return false
        }
        var sex = $('input[name="myGender"]:checked').val();
        var demolName = $('.form-control');
        if (demolName.length > 0) {
          for (var i = 0; i < demolName.length; i++) {
            var sel = $('.example').eq(i).find('select'),
              selName = '';
            for (var v = 0; v < 3; v++) {
              if (sel.eq(v).val() == '请选择') {
                var etSlebox = $('.content-block').offset().top;
                $('.example').addClass('font');
                $(window).scrollTop(etSlebox);
                return false;
              }
              if (sel.eq(v).length) {
                selName += sel.eq(v).val() + ',';
              } else {
                selName += '--' + ',';
              }
            }
            selName += $('.detailed').find('input').val();
          }
        }
        var content = {
          name: $('.myName').val(),
          sex: sex,
          address: selName || this.address,
          mobile: $('.myTelephone').val()
        };
        $.ajax({
          'url': API.SaveActivityUser,
          'data': {data: JSON.stringify(content)},
          'type': 'POST',
          'dataType': 'json',
          xhrFields: {
            withCredentials: true
          },
          crossDomain: true,
          success: function (res) {
            // console.log(res)
            if (res.code == 0) {
              $('#modal_content').css('left', '-120%');
            }
          }
        });
      }
    },
    components: {   // 渲染页面
      Linkage: Linkage,
      UserContentr: userContentr
    },
    created: function () {

      var that = this;
      if (that.IsPC()) {
        window.location.href = API.IsPcName
      }
      if(window.isThisClient('cbox')){
        console.log("mymessage");
         that.cboxregisterhandler();
      }
      if (that.loginFn()) {
        // console.log('login_check_success');
        that.MyPortrait = true;
        // 登录之后
        that.$http.get(API.GetCountByUserid)
          .then(function (res) {

            if (res.code == 0) {
              that.count = res.data;
              that.countmes = res.data.msg;
              that.nickname = res.data.nick_name;
              that.headPortrait = res.data.face_url
              that.userId = res.data.user_id;
            } else {
              that.MyPortrait = false
            }
          })
      } else {
        that.MyPortrait = false
      }

      var GetActivities = {
        pagesize: '10',
        page: 1,
        progress: 'on'
      };
      // 最新征集推荐
      that.$http.get(API.GetActivities, {params: GetActivities})
        .then(function (res) {
          if (res.code == '0') {
            that.TablesName = Math.floor(res.data.length / 2);
            that.Tables = res.data;
            that.$nextTick(function () {
              var swiperPoll = new Swiper('.show-poll-swiper', {
                loop: true,
                autoplayDisableOnInteraction: false
              });
              var picHimg = Math.ceil($('.pic-box').width() / 16 * 9);
              $('.pic-box').find('img').css({height: picHimg, visibility: 'visible'});
            });
          }
        });
      that.FileByUserid = {
        page: 1,
        pagesize: 1
      };
      // 获取上传个数
      that.$http.get(API.GetUploadFileForMe, {params: that.FileByUserid})
        .then(function (res) {
          if (res.code == 0) {
            that.total = res.total;
          }
        })
    },
    mounted: function () {
      // 操作DOM
      var that = this;
      if (window.isThisClient('cbox')) {
        $('.cbox').hide();
      }
      window.addEventListener("popstate", function (e) {
        $(".modal-backdrop").remove();
        var urlArr = (window.location.href).split('/');
        var len = urlArr.length;
        var name = urlArr[len - 1].toLowerCase();
        if (name == 'mymessage' || name == 'index') {
          window.location.reload()
        }
      }, false);
      // 微信分享
      let metas = $('head').children('meta');
      var dataName = {
        title: document.title,
        desc: that.removeTAG(metas[1].content, 110),
        imgAddress: 'http://userface.img.cctvpic.com/G01/M00/3E/0E/CkcBPVpAcZiAQwHXAAAJR49Qvog771.jpg',
        Retain: '',// 保留
        url: window.location.href
      };
      that.weixinShare(dataName)
    }
  }
</script>

<style>
  .nav-bottom {
    box-shadow: 0 1px 8px #888888;
  }

  #modal_content {
    position: fixed;
    top: 0;
    left: -120%;
    height: 100%;
    width: 100%;
    z-index: 999;
    transition: left .3s;
    -webkit-transition: left .3s;
    background: #e8e8e8;
    overflow-y: auto;
  }

  #modal_content .z-content, #modal_content .btn-modal-tw {
    padding: 15px;
  }

  #modal_content .z-content p {
    margin-bottom: 10px;
  }

  #modal_content label {
    display: block;
    margin-bottom: 10px;
    color: #666;
  }

  #modal_content select {
    height: 35px;
    color: #666;
  }

  #modal_content .myName, #modal_content .myTelephone {
    width: 100%;
    height: 40px;
    border: 1px solid #ccc;
    padding-left: 10px;
    color: #666;
  }

  #modal_content .btn-modal-tw {
    margin-top: 20px;
  }

  #modal_content .btn-modal-tw button {
    width: 45%;
    float: left;
    background: #cf5454;
    padding: 10px 0;
    text-align: center;
    text-decoration: none;
  }

  #modal_content .btn-modal-tw #cancel {
    float: right;
  }

  #modal_content .content-myGender {
    background: #fff;
    border: 1px solid #ccc;
    margin-bottom: 18px;
  }

  #modal_content .conten-span {
    padding-left: 2%;
    width: 40%;
    display: inline-block;
    height: 40px;
    line-height: 40px;
    color: #666;
  }

  #modal_content .cotent-sex {
    position: relative;
  }

  #modal_content .sex {
    float: left;
    margin-right: 10px;
    height: 15px;
    width: 15px;
    border-radius: 50%;
    margin-top: 11px;
  }

  #modal_content .active {
    height: 19px;
    width: 12px;
    margin-top: 10px;
    border: 2px solid #53b3e4;
    border-right: none;
    border-bottom: none;
    transform: rotate(-150deg);
    -webkit-transform: rotate(-150deg);
  }

  #modal_content .conten-span span {
    font-size: 0;
    float: right;
    margin-right: 30px
  }

</style>



// WEBPACK FOOTER //
// src/components/myMessage.vue